import React from "react";
import StatsListItem from "./StatsListItem";

export default function VerticalStatsList(props) {
	const { data } = props;
	let fields = data?.fields;
	let { stats, containerClasses = "" } = fields;
	if (!stats) {
		let statItems = fields?.statItems;

		return (
			<div className={`${containerClasses}`}>
				{statItems.map((statItem) => (
					<StatsListItem key={statItem.sys.id} statItem={statItem} />
				))}
			</div>
		);
	} else {
		return <></>;
	}
}
